/**
 * activity模块接口列表
 */
import base from './base'; // 导入接口域名列表
import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块


const activity = {
    //login 登陆接口    
    login(data) {
        return axios({
            withCredentials: true,
            crossDomain: true,
            method: "post",
            url:base+'rest/login',
            data: qs.stringify(data)
        });
    },
    // logout 退出登录接口
    logout(){
        return axios({
            withCredentials: true,
            crossDomain: true,
            method: "post",
            url:base+'rest/logout'
        });
    },
    // isLogin 判断是否登陆
    isLogin() {
        return axios({
            withCredentials: true,
            crossDomain: true,
            method: "get",
            url:base+'rest/is-login'
        })
    },
    //prizeList 奖品列表
    prizeList(){
        return axios({
            withCredentials: true,
            crossDomain: true,
            method: "get",
            url:base+'rest/lottery/prize-list'
        })
    },
    //myPrize 我的奖品
    myPrize(){
        return axios({
            withCredentials: true,
            crossDomain: true,
            method: "get",
            url:base+'rest/lottery/my-prize'
        })
    },
    //clickDraw 点击抽奖
    clickDraw(){
        return axios({
            withCredentials: true,
            crossDomain: true,
            method: "get",
            url:base+'rest/lottery/draw'
        })
    },
    //fillAddress 填写收件信息
    fillAddress(data){
        return axios({
            withCredentials: true,
            crossDomain: true,
            method: "get",
            url:base+'rest/lottery/fill-address',
            params:data
        })
    },
    // 记录信息
    recordInfo(data){
        return axios({
            withCredentials: true,
            crossDomain: true,
            method: "get",
            url:base+'rest/lottery/my-address',
            params:data
        })
    },
    //优惠券列表
    inventory(data){
        return axios({
            withCredentials: true,
            crossDomain: true,
            method: "get",
            url:base+'rest/mall/inventory',
            params:data
        })
    },
    //抢购优惠券接口 vid 库存ID address收件信息为游戏ID
    getDiscount(data){
        return axios({
            withCredentials: true,
            crossDomain: true,
            method: "get",
            url:base+'/rest/mall/buy',
            params:data
        })
    },
    //抽中优惠卷接口
    drawDiscount(data){
        return axios({
            withCredentials: true,
            crossDomain: true,
            method: "get",
            url:base+'/rest/lottery/award',
            params:data
        })
    },
    //签到
    signin(data){
        return axios({
            withCredentials: true,
            crossDomain: true,
            method:"get",
            url:base+'/rest/signin',
            params:data
        })
    },
    //是否已签到
    signinList(){
        return axios({
            withCredentials: true,
            crossDomain: true,
            method:"get",
            url:base+'/rest/is-signin',
        })
    }
}

export default activity;
